import { render, staticRenderFns } from "./SetupSorter.vue?vue&type=template&id=7dcaddeb&scoped=true"
import script from "./SetupSorter.vue?vue&type=script&lang=js"
export * from "./SetupSorter.vue?vue&type=script&lang=js"
import style0 from "./SetupSorter.vue?vue&type=style&index=0&id=7dcaddeb&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcaddeb",
  null
  
)

export default component.exports